<div class="select">
    <select class="select-text" required [(ngModel)]="defaultValue" (change)="onChange($event.target.value)">
        <option *ngFor="let option of options" [disabled]="isDisabled(option)" [value]="option.value">{{option.label}}</option>
    </select>
    <label class="select-label">{{label}}</label>
</div>